import { mdiLoading } from '@mdi/js';
import Icon from '@mdi/react';
import { useEffect, useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useParams } from 'react-router-dom';
import { useTranslate } from 'sbx-crm-menu-ui';
import NavbarBreadcrumbV2 from 'src/components/shared/NavbarBreadcrumbV2';
import botIcon from '../../../assets/images/SBX360Bot.png';
import { State } from '../../../types/State';
import { uuidV4 } from '../../../utils';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import ChatBotComponent, { ChatRefComponent } from './chatBotComponent/ChatBotComponent';
import SpeechManageTranscriptionComponent from './SpeechManageTranscriptionComponent';
import TranscriptionComponent from './TranscriptionComponent';


export default function SpeechToTextComponent() {
    const [loading, setLoading] = useState(State.IDLE);
    const { t: routes } = useTranslate('routes');
    const { t: common } = useTranslate('common');
    const { t: speech } = useTranslate('speech');
    const { t: report } = useTranslate('report');
    const { job_id } = useParams();
    const [transcription, setTranscription] = useState<string>('');
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        maxFiles: 1,
    });
    const chatBotRef = useRef<ChatRefComponent>(null);

    const [sessionId, setSessionId] = useState('');


    useEffect(() => {
        setSessionId(uuidV4());
    }, []);

    return (
        <div className='mt-5 pl-3'>
            <NavbarBreadcrumbV2 routes={[
                    {
                        label: speech('speech_to_text_list'),
                        route: '/speech-to-text/list'
                    },
                    {
                        label: routes('speech-to-text')
                    }
                ]} 
            />
            <div className="container mx-auto p-4 space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <Card className="md:row-span-1">
                        <CardHeader>
                            <CardTitle>{report('select')}</CardTitle>
                        </CardHeader>
                        <CardContent>

                            <section
                                className="">
                                <div {...getRootProps({ className: 'dropzone' })}
                                     className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center cursor-pointer h-64 flex flex-col justify-center">
                                    <input {...getInputProps()} />
                                    <p>{common('drag_and_drop')}</p>
                                </div>
                            </section>
                        </CardContent>
                    </Card>

                    <SpeechManageTranscriptionComponent setTranscription={setTranscription} setLoading={setLoading}
                                                        transcription={transcription} file={acceptedFiles[0]}
                                                        className="md:row-span-1" />

                    <Card className="md:col-span-1 row-span-2 border-none">
                        <CardHeader className="py-3">
                            <CardTitle className="flex items-center gap-2 py-0"><img src={botIcon} alt="bot_icon"
                                                                                     className="h-10 w-10" /> SBX360 AI</CardTitle>
                        </CardHeader>
                        <CardContent className="p-0">
                            <ChatBotComponent key={job_id === 'create' ? uuidV4() : job_id} sessionId={sessionId}
                                              transcription={transcription} ref={chatBotRef} />
                        </CardContent>
                    </Card>

                    {loading === State.PENDING ?
                        (
                            <div className="flex justify-center items-center h-64">
                                <Icon size={2} path={mdiLoading} className="text-primary" spin />
                            </div>
                        )
                        :
                        <TranscriptionComponent sessionId={sessionId} chatBotRef={chatBotRef} transcription={transcription}
                                                className={'md:col-span-2'} />
                    }


                </div>
            </div>
        </div>

    )
        ;
}